// Collection of helpers for generating reducers

import { DefaultState } from './DefaultState'

export function makeSingleObjectReducer (props) {
  const defaultState = props.default || { ...DefaultState }

  return (state = defaultState, action) => {
    switch (action.type) {
      case props.actionRequest:
        return {
          ...state,
          isFetching: true,
          didInvalidate: false
        }
      case props.actionFailure:
        return {
          ...state,
          isFetching: false,
          didInvalidate: false,
          error: action.error,
          lastUpdated: action.receivedAt
        }
      case props.actionReceive:
        return {
          ...state,
          isFetching: false,
          didInvalidate: false,
          details: action.response,
          error: null,
          lastUpdated: action.receivedAt
        }
      case props.actionInvalidate:
        return {
          ...state,
          didInvalidate: true
        }
      default:
        return state
    }
  }
}
